<template>
  <v-card class="card">
    <v-form ref="form" v-model="valid">
      <v-text-field
        name="company"
        label="Company"
        type="text"
        autocomplete="none"
        validate-on="blur"
        :maxLength="254"
        v-model="company"
        :rules="[rules.required]"
        variant="outlined"
        density="default"
      >
      </v-text-field>
      <v-text-field
        name="startDate"
        label="Start Date"
        type="date"
        autocomplete="none"
        validate-on="blur"
        v-model="startDate"
        :rules="[rules.required]"
        :error-messages="dateRangeErrorMessage"
        variant="outlined"
        density="default"
      ></v-text-field>

      <v-text-field
        name="expirationDate"
        label="Expiration Date"
        type="date"
        autocomplete="none"
        validate-on="blur"
        v-model="expirationDate"
        :rules="[rules.required]"
        :error-messages="dateRangeErrorMessage"
        variant="outlined"
        density="default"
      ></v-text-field>

      <v-text-field
        name="quantity"
        label="Quantity"
        type="number"
        autocomplete="none"
        validate-on="blur"
        v-model="quantity"
        :rules="[rules.required]"
        variant="outlined"
        density="default"
      >
      </v-text-field>

      <v-autocomplete
        name="payerUser"
        label="Payer User"
        :items="payerUserEmails"
        placeholder="Select payer user"
        validate-on="blur"
        v-model="payerUserEmail"
        :rules="[rules.required]"
        variant="outlined"
        density="default"
        @update:search="handlePayerUserSearch"
        :loading="loadingUsers"
      />

      <v-btn rounded="lg" size="large" color="#363a40" class="ml-auto d-flex" variant="flat" @click="submit"
             :loading="loadingAddEnterpriseCustomer"
             tabindex="3">
        Add Customer
      </v-btn>
    </v-form>
  </v-card>
</template>

<script>
import add from 'date-fns/add'
import format from 'date-fns/format'
import { mapState } from 'vuex'
import debounce from '@/utils/debounce'

export default {
  data: () => ({
    valid: true,
    company: '',
    quantity: '',
    payerUserEmail: null,
    startDate: format(new Date(), 'yyyy-MM-dd'),
    expirationDate: format(add(new Date(), { years: 1 }), 'yyyy-MM-dd'),
    rules: {
      required: (value) => !!value || 'Required.'
    },
    payerUserEmails: []
  }),
  computed: {
    ...mapState({
      users: state => state.user.users,
      loadingUsers: state => state.user.loadingUsers,
      nextTokenUsers: state => state.user.nextTokenUsers,
      loadingAddEnterpriseCustomer: state => state.enterpriseCustomers.loadingAddEnterpriseCustomer
    }),
    dateRangeErrorMessage () {
      return (new Date(this.startDate) >= new Date(this.expirationDate)) ? ['Start Date cannot be greater than Expiration Date.'] : []
    }
  },
  methods: {
    async submit () {
      const { valid } = await this.$refs.form.validate()
      if (valid) {
        const payerUser = this.users.find(user => user.email === this.payerUserEmail)
        const newEnterpriseUser = {
          company: this.company,
          startDate: this.startDate,
          expirationDate: this.expirationDate,
          quantity: +this.quantity,
          payerUserId: payerUser.id
        }

        const response = await this.$store.dispatch('enterpriseCustomers/addEnterpriseCustomer', newEnterpriseUser)
        if (response.success) {
          this.$refs.form.reset()
          this.$emit('onDone')
          this.$store.commit('snackbar/showMessage', { content: 'Enterprise customer has been added successfully.' }, { root: true })
          this.$store.dispatch('subscriptions/listSubscriptions')
          this.$store.dispatch('enterpriseCustomers/listEnterpriseCustomers')
        } else {
          this.$store.commit('snackbar/showMessage', {
            content: response.message,
            timeout: 6000,
            color: 'red',
            location: 'center center'
          }, { root: true })
        }
      }
    },
    handlePayerUserSearch: debounce(function (searchVal) {
      const searchTerm = (searchVal || '').trim()
      if (searchTerm.length > 0) {
        this.$store.dispatch('user/listUsers', {
          search: searchTerm,
          append: false,
          fetchAllForSearch: true
        })
      } else {
        this.fetchInitialUsers()
      }
    }, 500),

    fetchInitialUsers () {
      this.$store.dispatch('user/listUsers', { append: false, fetchAllForSearch: false })
    }
  },
  mounted () {
    this.fetchInitialUsers()
    this.$store.dispatch('enterpriseCustomers/listEnterpriseCustomers')
  },
  watch: {
    users (newUsers) {
      this.payerUserEmails = (newUsers || []).map((user) => user.email)
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 12px;
  background: #FCFCFC;
  border: 1px solid #FCFCFC;
  padding: 12px 16px 16px !important;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}
</style>
